import { EmbeddingsPage } from "../../../../pages/EmbeddingsPage";
import { appRouterPaths } from "../../../../services/navigation/urls";
import type { AppRouteProps } from "../../types";

export const embeddingsPageRouteConfig: AppRouteProps = {
  path: appRouterPaths.embeddings.root,
  element: <EmbeddingsPage />,
  name: "Эмбеддинги текстов",
};
